import React, { useState, useEffect } from 'react';
import { AlertTriangleOutline, SuccessCircleOutline, ChevronDownOutline } from '@olist/design-system-icons';
import { useSelect } from './SelectContext.js';
import { SelectMobileOptionalLabel, SelectWrapper, StyledSelect } from './styles.js';
import { Flex } from '../Flex/Flex.js';
import Caption from '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const feedbackIcon = {
    error: React.createElement(AlertTriangleOutline, { "aria-hidden": true }),
    valid: React.createElement(SuccessCircleOutline, { "aria-hidden": true }),
};
function SelectMobile({ children, required, id, label, feedback, readOnly, optionalLabel = '(opcional)', helperText, disabled, placeholder, }) {
    const [{ multi, onSelect, options }] = useSelect();
    const [value, setValue] = useState(multi ? [] : '');
    useEffect(() => {
        const preSelectedOptions = options
            .filter((option) => option.selected)
            .map((option) => option.value)
            .filter(Boolean);
        const initialValue = multi
            ? preSelectedOptions
            : preSelectedOptions[0] || '';
        setValue(initialValue);
    }, [options]);
    const handleSelect = (event) => {
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const selectedOptions = Array.from(event.target.selectedOptions).map((option) => {
            const parentElement = option.parentElement;
            const isOptgroup = (parentElement === null || parentElement === void 0 ? void 0 : parentElement.tagName) === 'OPTGROUP';
            const category = isOptgroup
                ? parentElement.getAttribute('label')
                : undefined;
            return {
                value: option.value,
                text: option.text,
                selected: true,
                id: option.id,
                category: category || undefined,
            };
        });
        setValue(multi ? selectedOptions.map((option) => option.value) : event.target.value);
        onSelect(selectedOptions);
    };
    return (React.createElement(Flex, { alignItems: "stretch", flexDirection: "column" },
        label && (React.createElement("div", null,
            React.createElement(ParagraphMd, { bold: true, as: "label", htmlFor: id }, label),
            !required && (React.createElement(SelectMobileOptionalLabel, null, optionalLabel)))),
        React.createElement(SelectWrapper, { feedback: feedback },
            React.createElement(StyledSelect, { onChange: handleSelect, multiple: multi, id: id, feedback: feedback, readOnly: readOnly, disabled: disabled, value: value, placeholder: placeholder, required: required },
                !required && React.createElement("option", { value: "" }),
                children),
            React.createElement(ChevronDownOutline, { "aria-hidden": true }),
            feedback && !disabled && !readOnly && feedbackIcon[feedback]),
        helperText && React.createElement(Caption, null, helperText)));
}

export { SelectMobile };
